module.exports = __webpack_public_path__ + "img/pota-5.8da0e423.png";